import { useCallback } from 'react';
import { trackFormInteraction, trackButtonClick } from '../utils/trackingUtils';
import { gtm } from '../utils/analytics';

export const useTracking = () => {
    // Track button clicks
    const trackButton = useCallback((buttonName, context = {}) => {
        trackButtonClick(buttonName, context);
    }, []);

    // Track form interactions
    const trackForm = useCallback((formName, interactionType, data = {}) => {
        trackFormInteraction(formName, interactionType, data);
    }, []);

    // Track form field focus/blur events
    const trackFormField = useCallback((fieldName, action, formName = 'unknown') => {
        gtm.pushEvent('form_field_interaction', {
            field_name: fieldName,
            field_action: action,
            form_name: formName,
            page_location: window.location.pathname
        });
    }, []);

    // Track email signups specifically
    const trackEmailSignup = useCallback((email, source = 'unknown', success = true) => {
        gtm.pushEvent('email_signup', {
            signup_source: source,
            signup_success: success,
            page_location: window.location.pathname
        });

        trackForm('email_signup', success ? 'success' : 'error', {
            source,
            success,
            emailProvided: !!email
        });
    }, [trackForm]);

    // Track waitlist join
    const trackWaitlistJoin = useCallback((data = {}, success = true) => {
        gtm.pushEvent('waitlist_join', {
            join_success: success,
            page_location: window.location.pathname,
            ...data
        });

        trackForm('waitlist', success ? 'success' : 'error', {
            success,
            ...data
        });
    }, [trackForm]);

    // Track section navigation
    const trackNavigation = useCallback((targetSection, method = 'click') => {
        gtm.pushEvent('navigation', {
            target_section: targetSection,
            navigation_method: method,
            current_page: window.location.pathname
        });
    }, []);

    // Track file downloads or external links
    const trackExternalAction = useCallback((actionType, target, context = {}) => {
        gtm.pushEvent('external_action', {
            action_type: actionType,
            action_target: target,
            page_location: window.location.pathname,
            ...context
        });
    }, []);

    return {
        trackButton,
        trackForm,
        trackFormField,
        trackEmailSignup,
        trackWaitlistJoin,
        trackNavigation,
        trackExternalAction
    };
};
